import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import UserDateFormat from '../../../components/user-date-format/index';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const RefundRequestedStartUtcColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { refundRequestedStartUtc } = fulfillment;

  if (!refundRequestedStartUtc) {
    return '';
  }

  return <UserDateFormat value={refundRequestedStartUtc} />;
};

RefundRequestedStartUtcColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const RefundRequestedStartUtc = {
  getMessageDescriptor: () => messages.refundRequestedStartUtc,
  id: 'refund-requested-start-utc',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RefundRequestedStartUtcColumn fulfillmentId={data.id} />;
  },
};
